import { WifiOff } from 'lucide-react';
import { useEnLigne } from '@/lib/reseau';

/**
 * Bandeau de coupure réseau.
 *
 * L'application s'ouvre désormais sans connexion — la coquille est en cache.
 * Mais tout ce qu'elle affiche vient du serveur : sans ce bandeau, l'écran
 * paraîtrait simplement en panne, et l'opérateur chercherait la faute du côté
 * de l'application plutôt que du côté de la box.
 *
 * Il dit aussi ce qui est perdu, pas seulement qu'il y a un problème : une
 * vente encaissée hors ligne ne part pas, et rien ne la rattrapera tout seul.
 */
export function BandeauHorsLigne() {
  const enLigne = useEnLigne();
  if (enLigne) return null;

  return (
    <div
      role="status"
      className="sans-impression flex items-center justify-center gap-2 bg-danger px-4 py-2 text-center text-sm font-medium text-white"
    >
      <WifiOff aria-hidden className="h-4 w-4 shrink-0" />
      <span>
        Hors ligne — les données affichées peuvent être périmées, et rien ne peut être enregistré
        tant que la connexion n’est pas revenue.
      </span>
    </div>
  );
}
